import { isDefined } from '@evorait/pace-core';
import { FUNCTION_LIMIT_RETURN_TYPE, FUNCTION_LIMIT_TYPE } from '../types/value-functional-element';

export class ValueUtilities {
    public static limitNumbers(inputValue: string, functionalAttribute: string): string {
        const [beforeDecimal, afterDecimal] = inputValue.split('.');
        const [beforeDecimalSlice, afterDecimalSlice] = functionalAttribute
            .split('.')
            .map((sliceValue) => Number(sliceValue));

        const afterDecimalValue =
            isDefined(afterDecimal) && isDefined(afterDecimalSlice) ? afterDecimal.slice(0, afterDecimalSlice) : '';

        const beforeDecimalValue =
            beforeDecimal.slice(0, beforeDecimalSlice) +
            (inputValue.includes('.') && functionalAttribute.includes('.') ? '.' : '');

        return beforeDecimalValue + afterDecimalValue;
    }

    public static getPlaceholderText(functionalAttribute: string | undefined): string {
        if (!isDefined(functionalAttribute)) return '';
        switch (functionalAttribute) {
            case FUNCTION_LIMIT_TYPE.TwoDigitsBeforeDecimal:
                return FUNCTION_LIMIT_RETURN_TYPE.TwoDigitsInteger;
            case FUNCTION_LIMIT_TYPE.TwoDigitsBeforeAndAfterDecimal:
                return FUNCTION_LIMIT_RETURN_TYPE.TwoDigitsDecimal;
            case FUNCTION_LIMIT_TYPE.ThreeDigitsBeforeDecimal:
                return FUNCTION_LIMIT_RETURN_TYPE.ThreeDigitsInteger;
            case FUNCTION_LIMIT_TYPE.ThreeDigitsBeforeAndAfterDecimal:
                return FUNCTION_LIMIT_RETURN_TYPE.ThreeDigitsDecimal;
            default:
                return '';
        }
    }
}
